import { compare, Operation } from 'fast-json-patch';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { Action } from '@ngrx/store';
import { CategoryType, ErrorModel } from '@rocksoft/shared';
import { catchErrorWithToast, IToastie } from '@rocksoft/shared/toast';
import { ApplicationConfiguration } from './category-applications/category-applications.state';
import { VppApplicationConfiguration } from './category-vpp-applications/category-vpp-applications.state';

export function compareApplications(action: {
  id: string;
  categoryType: CategoryType;
  previousApplicationsLinkedToCategory: ApplicationConfiguration[];
  updatedApplicationsLinkedToCategory: ApplicationConfiguration[];
}): Operation[] {
  return compare(
    action.previousApplicationsLinkedToCategory.map((x) => ({
      bundleIdentifier: x.bundleIdentifier,
      version: x.version,
      applyFrom: x.applyFrom instanceof Date ? x.applyFrom.toISOString() : x.applyFrom,
      applyTill: x.applyTill instanceof Date ? x.applyTill.toISOString() : x.applyTill,
    })),
    action.updatedApplicationsLinkedToCategory.map((x) => ({
      bundleIdentifier: x.bundleIdentifier,
      version: x.version,
      applyFrom: x.applyFrom instanceof Date ? x.applyFrom.toISOString() : x.applyFrom,
      applyTill: x.applyTill instanceof Date ? x.applyTill.toISOString() : x.applyTill,
    }))
  );
}

export function compareVppApplications(action: {
  categoryId: string;
  categoryType: CategoryType;
  previousApplicationsLinkedToCategory: VppApplicationConfiguration[];
  updatedApplicationsLinkedToCategory: VppApplicationConfiguration[];
}): Operation[] {
  return compare(
    action.previousApplicationsLinkedToCategory.map((x) => ({
      adamIdStr: x.adamIdStr,
      applyFrom: x.applyFrom instanceof Date ? x.applyFrom.toISOString() : x.applyFrom,
      version: x.version,
    })),
    action.updatedApplicationsLinkedToCategory.map((x) => ({
      adamIdStr: x.adamIdStr,
      applyFrom: x.applyFrom instanceof Date ? x.applyFrom.toISOString() : x.applyFrom,
      version: x.version,
    }))
  );
}

export function safeMap<T, A, E extends Action>(
  result: Observable<T> | (() => Observable<T>),
  createAction: (t: T) => A | A[],
  createError: (error: ErrorModel) => E,
  toastMessage?: string
): Observable<A | (E & { toast: IToastie })> {
  let sourceObservable: Observable<T>;
  if (typeof result == 'function') {
    sourceObservable = of(true).pipe(mergeMap(result));
  } else {
    sourceObservable = result;
  }

  return sourceObservable.pipe(
    mergeMap((x) => {
      const action = createAction(x);
      return Array.isArray(action) ? action : [action];
    }),
    catchErrorWithToast((error) => createError(error as ErrorModel), toastMessage)
  );
}
